module.exports = __webpack_public_path__ + "static/img/share_head.7c5eeab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/share_head.png
// module id = yTCu
// module chunks = 1